import { authApi } from '@xstudios/xapp-auth/services/authService'

export async function disconnectQuickBooks() {
  const { data } = await authApi.post('/quickbooks/disconnect')
  return data
}

export async function getQuickBooksConnectUrl(returnTo = '/') {
  const { data } = await authApi.get('/quickbooks/connect', {
    params: { return_to: returnTo },
  })
  return data?.auth_url || ''
}

export async function getQuickBooksStatus() {
  const { data } = await authApi.get('/quickbooks/status')
  return data
}
